import {useState} from 'react'
import FieldExecutiveChangeForm from './FieldExecutiveChangeForm';
import FieldExecutiveChangeList from './FieldExecutiveChangeList';

const FieldExecutiveChange = () => {

    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <FieldExecutiveChangeForm addForm={setFromIsShown} update={upData} />
        ) : (
          <FieldExecutiveChangeList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default FieldExecutiveChange